import type { EventStage } from "../../types/explorer";

export const EVENT_STAGE_TONE: Record<EventStage, string> = {
  onset: "bg-info/15 text-info",
  mature: "bg-accent/15 text-accent",
  decay: "bg-info/15 text-info",
  unknown: "bg-elevated/70 text-faint",
};

export const EVENT_STAGE_TEXT_TONE: Record<EventStage, string> = {
  onset: "text-info",
  mature: "text-accent",
  decay: "text-info",
  unknown: "text-faint",
};

export const CNN_ONLY_TONE =
  "rounded-md border border-warn/55 bg-warn/15 px-2 py-0.5 text-[11px] font-semibold text-warn";

export const PATTERN_TONE =
  "rounded-md border border-warn/55 bg-warn/15 px-2 py-0.5 text-[11px] font-semibold text-warn";
